var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _g2, _path10, _g3, _path11, _g4, _path12, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKoupanaFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 75,
    viewBox: "0 0 392 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.731 38.0541L103.139 33.9041L97.1677 26.9961L93.7996 31.1117V8.2998H83.5923V60.4621H93.7996V37.0144L112.943 60.4621H126.106L106.731 38.0541ZM109.609 22.4509L105.253 23.0953V20.4919L101.996 21.2996L101.945 21.0934L97.1591 26.9961L101.85 35.3819L103.131 33.9041L110.09 25.8706L109.609 22.4509ZM112.47 8.2998L104.445 18.1033L107.873 17.2613V20.0623L111.963 19.4609L112.479 23.1125L125.307 8.2998H112.47Z",
    fill: "#211F44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.513 20.0195C131.072 20.0195 122.291 28.792 122.291 40.7607C122.291 52.7209 131.072 61.5019 143.513 61.5019C155.954 61.5019 164.727 52.7209 164.727 40.7607C164.727 28.792 155.954 20.0195 143.513 20.0195ZM143.513 52.6435C136.571 52.6435 131.862 47.7031 131.862 40.7607C131.862 33.8183 136.571 28.8779 143.513 28.8779C150.447 28.8779 155.078 33.8183 155.078 40.7607C155.078 47.7031 150.447 52.6435 143.513 52.6435Z",
    fill: "#211F44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.502 21.0591V41.5597C198.502 49.052 194.507 52.6434 188.527 52.6434C182.547 52.6434 178.56 49.052 178.56 41.5597V21.0591H169.066V41.5597C169.066 54.8 176.885 61.5019 188.527 61.5019C200.178 61.5019 207.988 54.7141 207.988 41.5597V21.0591H198.502Z",
    fill: "#211F44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M233.592 20.0195C221.228 20.0195 212.619 28.3194 212.619 41.0786V75H222.104V54.7142C224.897 59.1047 229.605 61.5019 235.267 61.5019C244.839 61.5019 254.892 54.6369 254.892 41.156C254.892 28.6373 246.119 20.0195 233.592 20.0195ZM233.669 52.6435C226.735 52.6435 222.104 47.7031 222.104 40.7607C222.104 33.8183 226.735 28.8779 233.669 28.8779C240.612 28.8779 245.32 33.8183 245.32 40.7607C245.32 47.7031 240.612 52.6435 233.669 52.6435Z",
    fill: "#211F44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M280.359 20.0195C267.84 20.0195 259.067 28.6373 259.067 41.156C259.067 54.6369 269.112 61.5019 278.683 61.5019C284.904 61.5019 290.248 58.5463 292.645 52.7209V60.4623H301.34V41.0786C301.34 28.3968 292.722 20.0195 280.359 20.0195ZM280.281 52.6435C273.339 52.6435 268.639 47.7031 268.639 40.7607C268.639 33.8183 273.339 28.8779 280.281 28.8779C287.224 28.8779 291.846 33.8183 291.846 40.7607C291.846 47.7031 287.224 52.6435 280.281 52.6435Z",
    fill: "#211F44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M325.424 20.0195C313.782 20.0195 305.963 26.7987 305.963 39.9617V60.4623H315.457V39.9617C315.457 32.4608 319.444 28.8779 325.424 28.8779C331.404 28.8779 335.391 32.4608 335.391 39.9617V60.4623H344.885V39.9617C344.885 26.7213 337.066 20.0195 325.424 20.0195Z",
    fill: "#211F44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M370.36 20.0195C357.833 20.0195 349.061 28.6373 349.061 41.156C349.061 54.6369 359.113 61.5019 368.685 61.5019C374.905 61.5019 380.25 58.5463 382.638 52.7209V60.4623H391.333V41.0786C391.333 28.3968 382.724 20.0195 370.36 20.0195ZM370.274 52.6435C363.34 52.6435 358.632 47.7031 358.632 40.7607C358.632 33.8183 363.34 28.8779 370.274 28.8779C377.217 28.8779 381.848 33.8183 381.848 40.7607C381.848 47.7031 377.217 52.6435 370.274 52.6435Z",
    fill: "#211F44"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_670",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 0,
    width: 41,
    height: 12
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.771 0.0258789L23.817 11.8056H51.5092V0.0258789H11.771Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5092 0.0258789H11.771V11.8056H51.5092V0.0258789Z",
    fill: "url(#paint0_linear_2_670)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2_670",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 56,
    width: 34,
    height: 12
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7999 56.166L11.7539 67.9543H44.7302V56.166H23.7999Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2_670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7302 56.166H11.7539V67.9543H44.7302V56.166Z",
    fill: "url(#paint1_linear_2_670)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2_670",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 33,
    width: 25,
    height: 35
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0772 42.1783L58.2626 56.1662H44.3865L44.0342 67.9545H56.2521C61.3987 67.9545 65.9783 64.8871 67.9201 60.1099C69.8705 55.3499 68.7449 49.937 65.0675 46.3455L52.4974 33.9386L52.4802 33.9214L44.0772 42.1783Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2_670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.2435 21.0249L86.8483 50.0059L57.6525 80.8513L27.0391 51.8704L56.2435 21.0249Z",
    fill: "url(#paint2_linear_2_670)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2_670",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 53,
    height: 49
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0772 42.1785V42.1871L52.4373 33.9902L52.4888 33.9387L52.4716 33.9215L44.0772 42.1785ZM11.8055 0.0602544C5.22398 0.481265 0 5.98017 0 12.6734V48.4421H11.7797V47.5915L11.7883 10.7316L35.6227 33.9902L44.0257 25.7505L29.7972 11.8056L21.4372 3.61735L21.4028 3.583C21.2138 3.41116 21.0334 3.23931 20.8529 3.09325C20.6553 2.92141 20.4577 2.75816 20.2686 2.61209C20.2515 2.6035 20.2429 2.59491 20.2343 2.58632C20.0281 2.43166 19.8304 2.28559 19.6242 2.14812C19.418 2.00205 19.2118 1.88177 19.0056 1.75289C18.8166 1.64978 18.6448 1.54667 18.4643 1.45216C18.344 1.39202 18.2237 1.33188 18.0949 1.27174C18.0003 1.22018 17.8972 1.17722 17.8027 1.13426C17.6996 1.08271 17.6051 1.03974 17.4934 0.996785C17.4591 0.979601 17.4161 0.962419 17.3731 0.945234C17.2528 0.893682 17.1325 0.850719 17.0208 0.807759C16.7545 0.713246 16.4968 0.618736 16.2132 0.541407C15.0533 0.197725 13.8504 0.0258789 12.6217 0.0258789C12.3468 0.0258789 12.0718 0.0344783 11.8055 0.0602544Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2_670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.7017 38.3034L10.9977 -21.334L72.1903 10.173L41.4909 69.8018L-19.7017 38.3034Z",
    fill: "url(#paint3_linear_2_670)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2_670",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 68
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8904 0.0257751L51.5176 11.8055H58.2624L44.0339 25.7418L35.6309 33.9816L30.5616 38.9392L30.553 38.9306L11.7966 57.2316L11.788 50.9251V47.5828L0.00830078 47.2992V55.2898C0.00830078 59.6546 2.21645 63.5038 5.58453 65.7807C6.08287 66.1158 6.61557 66.4251 7.16547 66.6915C7.53492 66.8719 7.913 67.0352 8.29105 67.1726C8.68628 67.3101 9.0729 67.4476 9.47673 67.5421C10.482 67.7999 11.5388 67.9459 12.63 67.9459C13.8415 67.9459 15.053 67.7741 16.2387 67.4218C16.5222 67.3359 16.78 67.25 17.0291 67.1554C17.1494 67.1125 17.2611 67.0695 17.3814 67.018C17.4244 67.0094 17.4674 66.9922 17.5017 66.9664C17.6048 66.9235 17.7079 66.8805 17.811 66.8289C17.9141 66.7774 18.0086 66.743 18.1032 66.6915C18.2234 66.6399 18.3523 66.5712 18.4726 66.5024C18.653 66.4079 18.8249 66.3134 19.0053 66.2103C19.2201 66.09 19.4177 65.9612 19.6239 65.8237C19.8387 65.6776 20.0278 65.5401 20.234 65.3769C20.2426 65.3769 20.2598 65.3683 20.2598 65.3511C20.4574 65.2051 20.6464 65.0418 20.8526 64.87C21.0331 64.7153 21.2135 64.5435 21.3939 64.3716L38.9646 47.1618L44.0254 42.2041H44.0339L44.0855 42.1612L44.0769 42.1526L52.4799 33.8956L52.4971 33.9128L65.0673 21.6004C68.7447 18.0004 69.8703 12.5873 67.9199 7.83594C65.9781 3.06736 61.3985 0 56.2518 0H50.8904V0.0257751Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2_670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.578 48.4849L20.0193 99.5389L-30.7168 19.4954L49.8423 -31.5586L100.578 48.4849Z",
    fill: "url(#paint4_linear_2_670)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_670",
    x1: 11.7727,
    y1: 5.89639,
    x2: 51.5135,
    y2: 5.89639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01E5C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00408102,
    stopColor: "#01E5C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01D893"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_670",
    x1: 21.6465,
    y1: 62.0547,
    x2: 41.2218,
    y2: 62.0547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01BD76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00408127,
    stopColor: "#01BD76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BD76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_670",
    x1: 44.4048,
    y1: 39.0519,
    x2: 52.477,
    y2: 46.6947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01BD76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00408127,
    stopColor: "#01BD76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BD76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_670",
    x1: 14.5914,
    y1: 46.8831,
    x2: 25.7976,
    y2: 25.1147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01E4BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00408078,
    stopColor: "#01E4BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BD76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_670",
    x1: 70.4095,
    y1: 11.4784,
    x2: -1.32412,
    y2: 56.9402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00408127,
    stopColor: "#01D791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01E5C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoupanaFull);
export default __webpack_public_path__ + "static/media/koupana-full.18f6d7ad4e71056878fa0da58c401490.svg";
export { ForwardRef as ReactComponent };